<template>
	<thead>
		<tr class="row">
			<th v-for="s in sortables" :key="s.column || s.label" class="column">
				<template v-if="s.column">
					<router-link :to="s.to" class="column__sort">{{
						s.label
					}}</router-link>
					<span v-if="s.arrow" class="column__arrow" :class="s.arrow"></span>
				</template>
				<p v-else class="column__sort">{{ s.label }}</p>
			</th>
		</tr>
	</thead>
</template>

<script>
import query from '@/lib/query'

const parseSort = sort =>
	sort.split(',').reduce((acc, s) => {
		const [col, dir] = s.split(':')
		return { ...acc, [col]: dir }
	}, {})

const flip = dir => (dir === 'ASC' ? 'DESC' : 'ASC')

export default {
	name: 'StrapiSortableHeader',
	props: {
		columns: Array,
		validator: v => v.every(i => i.column || i.label)
	},
	computed: {
		sortables() {
			// Parse sort data from route
			const qsSort = this.$route.query._sort
			const qsSortObj = parseSort(qsSort || '')
			return this.columns.map(({ label, column, sort }) => {
				const dir = qsSort ? qsSortObj[column] : sort
				return {
					label,
					column,
					to: query.sort(this.$route, column, dir ? flip(dir) : 'ASC'),
					arrow: dir && dir.toLowerCase()
				}
			})
		}
	}
}
</script>

<style lang="scss" scoped>
@use "sass:math";
@import '~scss/vars';

.row {
	background-color: $grey-95;
}

.column {
	&__sort {
		color: $black;
		text-decoration: none;
		text-transform: uppercase;
	}

	a:hover {
		text-decoration: underline;
	}

	&__arrow {
		$size: 0.25rem;
		display: inline-block;
		width: 0;
		height: 0;
		border: $size solid transparent;
		border-bottom-color: $black;
		margin-left: 0.5rem;
		margin-bottom: math.div($size, 4);
		&.asc {
			transform: translateY(math.div(-$size, 2));
		}
		&.desc {
			transform: translateY(math.div($size, 2)) rotate(0.5turn);
		}
	}
}
</style>
